import React from "react";
import {
	Button,
	Avatar,
	Link,
} from "@mui/material";

export const Logo = () => {
	return (
		<>
			<Button
				color="inherit"
				component={Link}
				href={"/"}
				sx={{ border: "none", margin: 0, padding: 0 }}
			>
				<Avatar
					src={"/logo/gonini-logo-white.svg"}
					alt="Gonini"
					title="Gonini"
					variant="square"
					imgProps={{ style: { objectFit: "contain" } }}
					sx={{ width: "70px", height: "26px", bgcolor: "transparent" }}
				>
				</Avatar>
			</Button>        
		</>
	);
};
